import React, { useState } from 'react';
import logo from "../assets/logoss.png";
import { API_URL } from '../../Constants';
import { FiDownload, FiCheckCircle, FiInfo } from 'react-icons/fi';

const Generateleads = () => {
  const [isDownloading, setIsDownloading] = useState(false);

  const handleDownload = () => {
    const token = localStorage.getItem('token');
    if (!token) {
      alert('You are not logged in. Please log in and try again.');
      return;
    }

    setIsDownloading(true);
    window.location.href = `${API_URL}/api/public/files/download/Lead_Hunter_Pro.msi?token=${token}`;
    setTimeout(() => setIsDownloading(false), 3000);
  };

  return (
    <div className="min-h-screen bg-[#f0EFEB] flex flex-col font-sans">
      
      {/* Header Section - Padding aur margin bilkul kam kar di hai */}
      <header className="bg-[#f0EFEB] w-full pt-4 pb-0 px-8 flex items-center">
        <div className="flex justify-center mx-auto text-center pointer-events-none">
          <img
            src={logo}
            alt="Company Logo"
            className="h-14 w-auto object-contain rounded"
          />
        </div>
      </header>

      {/* Main Section - justify-start content ko upar push karega */}
      <main className="flex-grow flex flex-col items-center justify-start px-4 pt-2 pb-10">
        
        {/* Title Section - Margin Bottom (mb-4) kam kiya gaya hai */}
        <div className="text-center mb-4">
          <p className="text-gray-600 text-sm flex items-center justify-center gap-2">
            <FiInfo size={14} /> Get the desktop application to start generating leads.
          </p>
        </div>

        {/* Download Button Section - Margin Bottom (mb-6) kam kiya gaya hai */}
        <div className="mb-6 text-center">
          <button
            onClick={handleDownload}
            disabled={isDownloading}
            className={`flex items-center gap-3 px-8 py-3 text-base font-bold rounded-xl shadow-md transition-all duration-300 ease-in-out transform hover:-translate-y-1 ${
              isDownloading
                ? 'bg-gray-400 cursor-not-allowed text-white'
                : 'bg-[#0C4550] text-[#C5F637] hover:bg-[#0A3A43] hover:shadow-lg'
            }`}
          >
            <FiDownload className={isDownloading ? "animate-bounce" : ""} />
            {isDownloading ? 'Starting Download...' : 'Download Now'}
          </button>
        </div>

        {/* About Card - Content bilkul same rakha gaya hai */}
        <div className="max-w-3xl w-full bg-white rounded-2xl shadow-sm border border-gray-200 p-8">
          <h2 className="text-xl font-bold text-[#0C4550] border-b border-gray-100 pb-4 mb-6 uppercase tracking-wide text-sm">
            About the Application
          </h2>

          <ul className="space-y-5 text-gray-700">
            <li className="flex items-start">
              <div className="bg-emerald-50 p-1 rounded-full mr-4 mt-1 border border-emerald-100">
                <FiCheckCircle className="text-emerald-600" />
              </div>
              <span>
                <strong className="text-[#0C4550]">Generate Business Leads:</strong> Seamlessly extract high-quality B2B prospects directly from Google to grow your network.
              </span>
            </li>
            <li className="flex items-start">
              <div className="bg-emerald-50 p-1 rounded-full mr-4 mt-1 border border-emerald-100">
                <FiCheckCircle className="text-emerald-600" />
              </div>
              <span>
                <strong className="text-[#0C4550]">Strictly B2B Focus:</strong> Designed exclusively for corporate growth. The application filters out personal contacts to keep your lists purely business-oriented.
              </span>
            </li>
            <li className="flex items-start">
              <div className="bg-emerald-50 p-1 rounded-full mr-4 mt-1 border border-emerald-100">
                <FiCheckCircle className="text-emerald-600" />
              </div>
                <span>
                <strong className="text-[#0C4550]">Eurofox Integration:</strong> Connect directly to Eurofox to launch automated, targeted marketing campaigns using your newly acquired data.
              </span>
            </li>
            <li className="flex items-start">
              <div className="bg-emerald-50 p-1 rounded-full mr-4 mt-1 border border-emerald-100">
                <FiCheckCircle className="text-emerald-600" />
              </div>
                  <span>
                <strong className="text-[#0C4550]">Easy Exports:</strong> Export your generated lists instantly for use in CRMs, spreadsheets, or offline analysis.
              </span>
            </li>
          </ul>

          {/* Footer Call to Action */}
          <div className="mt-10 bg-[#0C4550]/5 p-6 rounded-xl border border-[#0C4550]/10 text-center">
            <p className="text-[#0C4550] font-semibold">
              Ready to supercharge your outreach? <br />
              <span className="text-sm font-normal text-gray-600">Click the button above to install the application and start hunting today!</span>
            </p>
          </div>
        </div>

      </main>
    </div>
  );
};

export default Generateleads;